import React, { useRef, useEffect } from 'react';
import { Line } from 'react-chartjs-2';

const CombinedChart = ({ datasets, onChartReady }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && onChartReady) {
      onChartReady(chartRef.current);
    }
  }, [datasets, onChartReady]);

  const yAxes = Object.fromEntries(
    datasets.map((ds, idx) => [
      ds.yAxisID,
      {
        type: 'linear',
        display: true,
        position: idx % 2 === 0 ? 'left' : 'right',
        title: { display: true, text: ds.label },
        grid: { drawOnChartArea: idx === 0 }
      }
    ])
  );

  const chartData = {
    datasets,
  };

  return (
    <Line
      ref={chartRef}
      data={chartData}
      options={{
        responsive: true,
        scales: {
          x: { type: 'time', time: { unit: 'month' } },
          ...yAxes
        },
        plugins: {
          tooltip: {
            bodyFont: { size: 12 },
            titleFont: { size: 14 }
          }
        }
      }}
    />
  );
};

export default CombinedChart;